import { render, staticRenderFns } from "./Responses.vue?vue&type=template&id=85e2b194&scoped=true"
import script from "./Responses.vue?vue&type=script&lang=js"
export * from "./Responses.vue?vue&type=script&lang=js"
import style0 from "./Responses.vue?vue&type=style&index=0&id=85e2b194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e2b194",
  null
  
)

export default component.exports